import { Button, Result, Row } from 'antd';
import { MouseEventHandler, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorFallbackProps } from './ErrorBoundary';

const defaultAction = () => window.location.reload();

const styles = { root: { height: '100%' } };

const ErrorFallback = (props: ErrorFallbackProps) => {
    const { t } = useTranslation('error');
    const {
        actionButtonText = t('button.back'),
        antdProps = {},
        fixedHeight = false,
        onActionButtonClick = defaultAction
    } = props;

    const { title = t('error.title'), subTitle = t('error.message'), status = '500' } = antdProps;

    const [isLoading, setIsLoading] = useState(false);

    const handleOnClick: MouseEventHandler<HTMLElement> = useCallback(async () => {
        setIsLoading(true);
        await onActionButtonClick();
        setIsLoading(false);
    }, [onActionButtonClick]);

    return (
        <Row style={fixedHeight ? {} : styles.root} align="middle" justify="center">
            <Result
                {...antdProps}
                status={status}
                title={title}
                subTitle={subTitle}
                extra={
                    <Button loading={isLoading} type="primary" onClick={handleOnClick}>
                        {actionButtonText}
                    </Button>
                }
            />
        </Row>
    );
};

export default ErrorFallback;
